<div class="card">
  <h3 class="card__title">Devices in Patch Cycle</h3>
  <div class="devices">
    <div class="devices__num">{{ summary.devicesInCycle }}</div>
    <div class="devices__split">
      <div
        class="devices__metric is-installed"
        [class.is-active]="activeStatus === 'Installed'"
        tabindex="0"
        (click)="statusSelect.emit('Installed')"
        (keydown.enter)="statusSelect.emit('Installed')"
      >
        <span class="lbl">Installed Patches</span>
        <span class="val">{{ summary.installedPatches | number }}</span>
      </div>
      <div
        class="devices__metric is-missing"
        [class.is-active]="activeStatus === 'Missing'"
        tabindex="0"
        (click)="statusSelect.emit('Missing')"
        (keydown.enter)="statusSelect.emit('Missing')"
      >
        <span class="lbl">Missing Patches</span>
        <span class="val">{{ summary.missingPatches | number }}</span>
      </div>
    </div>
  </div>
</div>
